const games_pt = require('./games.json')
export default games_pt
